import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Calendar, MapPin, Clock, Send } from 'lucide-react';

interface CreateEventSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (eventJson: string) => void;
}

export function CreateEventSheet({ isOpen, onClose, onSend }: CreateEventSheetProps) {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');

  const handleSend = () => {
    if (!title.trim() || !date) return;
    const event = {
      title: title.trim(),
      date,
      time: time || undefined,
      location: location.trim() || undefined,
      description: description.trim() || undefined,
      rsvps: {},
    };
    onSend(JSON.stringify(event));
    setTitle(''); setDate(''); setTime(''); setLocation(''); setDescription('');
    onClose();
  };

  return (
    <Sheet open={isOpen} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" className="rounded-t-2xl pb-8">
        <SheetHeader className="mb-4">
          <SheetTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-primary" />
            Create Event
          </SheetTitle>
        </SheetHeader>
        <div className="space-y-3">
          <Input
            placeholder="Event title *"
            value={title}
            onChange={e => setTitle(e.target.value)}
            className="rounded-xl"
          />
          <div className="flex gap-2">
            <div className="flex-1 relative">
              <Input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
                className="rounded-xl"
              />
            </div>
            <div className="w-32 relative">
              <Input
                type="time"
                value={time}
                onChange={e => setTime(e.target.value)}
                className="rounded-xl"
                placeholder="Time"
              />
            </div>
          </div>
          <Input
            placeholder="Location (optional)"
            value={location}
            onChange={e => setLocation(e.target.value)}
            className="rounded-xl"
          />
          <Textarea
            placeholder="Description (optional)"
            value={description}
            onChange={e => setDescription(e.target.value)}
            className="rounded-xl resize-none"
            rows={2}
          />
          <Button
            onClick={handleSend}
            disabled={!title.trim() || !date}
            className="w-full rounded-xl h-11"
          >
            <Send className="h-4 w-4 mr-2" />
            Send Event
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
